/**
 * Detail Long description snippet
 *
 * @author Mautilus s.r.o.
 * @class Snippet_Detail_Long_Description
 * @extends Snippet
 */

Snippet_Detail_Long_Description = (function(Snippet) {

	var Snippet_Detail_Long_Description = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_Detail_Long_Description.prototype, Snippet.prototype, {

		/**
		 * @inheritdoc Snippet#init
		 */
		init: function(){
			this.closeButton =
			'<li class="focusable button" data-action="close-description">' +
			'	<div class="name">' + __('close_description') + '</div>' +
			'</li>';
			this.scrollable = false;
			this.offset = 0;
			this.offsetStep = 40;
		},

		/**
		 * @inheritdoc Snippet#create
		 */
		create: function() {
			return $('<div id="snippet-detail-long-description" />');
		},

		/**
		 * @inheritdoc Snippet#render
		 * @param {Object} movie (Asset Model)
		 */
		render: function(descriptionText) {
			var descriptionHtml =
			'<div class="button-before">' +
			'	<ul>' +
					this.closeButton +
			'	</ul>' +
			'</div>' +
			'<div class="focusable description-area">' + descriptionText + '</div>' +
			'<div class="button-after">' +
			'	<ul>' +
					this.closeButton +
			'	</ul>' +
			'</div>' +
			'<div class="nav-up clickable" data-action="up"></div>' +
			'<div class="nav-down clickable" data-action="down"></div>';

			this.$el.html(descriptionHtml);
			this.$upArrow = this.$el.find('.nav-up');
			this.$downArrow = this.$el.find('.nav-down');
		},

		showButtonAfter: function() {
			if (this.scrollHeight >= 300){
				this.scrollable = true;
				$('.button-after', this.$el).css('display', 'block');
				this.scrollableAreaOffset = parseInt($('.scrollable-area', this.parent.$el).css('top').slice(0, -2));
				this.scrollHeight -= 250;
			} else {
				$('.button-after', this.$el).css('display', 'none');
				this.scrollable = false;
			}
		},

		/**
		 * @inheritdoc Snippet#navigate
		 */
		navigate: function(direction){
			if(direction == 'up'){
				return this.moveUp();

			}else if(direction == 'down'){
				return this.moveDown();
			}
		},
		
		moveUp: function() {
			if (this.scrollable) {
					if ((this.offset - this.offsetStep) >= 0) {
						if (this.scrollHeight === this.offset) {
							Focus.to(this.getFocusable(-1, true));
						}
						this.offset -= this.offsetStep;
						$('.scrollable-area', this.parent.$el).css('top', (this.scrollableAreaOffset - this.offset));
						this.$downArrow.removeClass('hide');
						return true;
					} else if ((this.offset - this.offsetStep) < 0) {
						this.offset = 0;
						$('.scrollable-area', this.parent.$el).css('top', (this.scrollableAreaOffset - this.offset));
						this.$upArrow.addClass('hide');
						return Focus.to(this.getFocusable(-1, true));;
					}
			} else {
				return false;
			}
		},

		moveDown: function() {
			if (this.scrollable) {
				if (this.scrollHeight >= (this.offset + this.offsetStep)) {
					if (0 === this.offset) {
						Focus.to(this.getFocusable(1, true));
					}
					this.offset += this.offsetStep;
					$('.scrollable-area', this.parent.$el).css('top', (this.scrollableAreaOffset - this.offset));
					this.$upArrow.removeClass('hide');
					return true;
				} else if (this.scrollHeight < (this.offset + this.offsetStep)) {
					this.offset = this.scrollHeight;
					$('.scrollable-area', this.parent.$el).css('top', (this.scrollableAreaOffset - this.offset));
					this.$downArrow.addClass('hide');
					return Focus.to(this.getFocusable(1, true));
				}
			} else {
				return false;
			}
		},

		show: function() {
			$('[class*="nav-"]', this.parent.$el).addClass('hide');
			$('#snippet-detail-buttons', this.parent.$el).css('display', 'none');
			$('.overlay', this.parent.$el).css('display', 'block');
			this.$el.css('display', 'block');
			this.scrollHeight = parseInt(this.$el.css('height').slice(0, -2));
			this.showButtonAfter();
			this.focus();
			this.isVisible = true;
			if (this.scrollable) this.$downArrow.removeClass('hide');
		},

		hide: function() {
			$('[class*="nav-"]', this.parent.$el).removeClass('hide');
			this.offset = 0;
			this.$el.css('display', 'none');
			$('.overlay', this.parent.$el).css('display', 'none');
			$('#snippet-detail-buttons', this.parent.$el).css('display', 'block');
			$('.scrollable-area', this.parent.$el).css('top', (this.scrollableAreaOffset));
			this.parent.focus();
			this.isVisible = false;
		},

		/**
		 * @inheritdoc Snippet#focus
		 */
		focus: function(){
			return Focus.to(this.getFocusable(0, true));
		},

		onReturn: function() {
			if(this.isVisible) {
				this.hide();
				return false;
			}

		},

		/**
		 * @inheritdoc Snippet#onScroll
		 */
		onScroll: function($el, delta, e, stop) {
			if (this.isVisible)
				if (delta > 0) {
					this.moveUp();
				} else {
					this.moveDown();
				}
			else return false;
		},
	});

	return Snippet_Detail_Long_Description;

})(Snippet);



//////////////////
// WEBPACK FOOTER
// ./js/snippet/detail_long_description.js
// module id = 65
// module chunks = 0